module.exports = __webpack_public_path__ + "static/media/icon_04.07a9f493.png";